module.exports = "https://cdn.hellotech.com/client-assets/samsung_cf2a0d12da1e060d255d7f66cf78770d.svg";